import { render, staticRenderFns } from "./kra.vue?vue&type=template&id=1451f56d"
import script from "./kra.vue?vue&type=script&lang=js"
export * from "./kra.vue?vue&type=script&lang=js"
import style0 from "./kra.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/kra.vue
// module id = tWSg
// module chunks = 0